export const ONLY_CYRILLIC = new RegExp('^[?!,.а-яА-ЯёЁs]+$');
export const ONLY_ENGLISH = new RegExp('^[a-zA-Z]+$');
export const ONLY_NUMBERS = new RegExp('^[0-9]+$');
